<template>
  <v-row>
    <v-col>
      <v-text-field
        :disabled="readonly"
        label="Prognos"
        outlined
        v-model="model"
      />
    </v-col>
  </v-row>
</template>

<script>
import { sync } from 'vuex-pathify'

export default {
  name: 'OdocPrognosInput',

  props: {
    readonly: Boolean
  },

  computed: {
    model: sync('odoc/model@prognos')
  }
}
</script>
